var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleMissedVoiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FF3A5E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0334 14.431C18.0518 14.1062 18.0009 13.7734 17.8734 13.4546L16.9868 11.238C16.6071 10.2889 15.6878 9.6665 14.6656 9.6665H12.2645C11.5755 9.6665 10.9147 9.94022 10.4275 10.4275C9.94022 10.9147 9.6665 11.5755 9.6665 12.2645C9.6665 12.2814 9.66702 12.2983 9.66804 12.3151C9.83843 15.1189 10.7936 17.8002 12.4007 20.0637L18.0334 14.431Z",
    fill: "#FF3A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8199 24.0013L9.91058 24.9106C9.58514 25.236 9.58514 25.7637 9.91058 26.0891C10.236 26.4145 10.7637 26.4145 11.0891 26.0891L14.6252 22.553C17.1275 24.7907 20.3177 26.127 23.6846 26.3316C23.7014 26.3327 23.7183 26.3332 23.7351 26.3332C24.4242 26.3332 25.085 26.0595 25.5722 25.5722C26.0595 25.085 26.3332 24.4242 26.3332 23.7351V21.3341C26.3332 20.3118 25.7108 19.3926 24.7616 19.0129L22.5451 18.1263C21.504 17.7099 20.3145 18.1105 19.7376 19.0721C19.5545 19.3773 19.2445 19.3984 19.0779 19.2855C18.8439 19.1267 18.6179 18.9572 18.4007 18.7774L26.0891 11.0891C26.4145 10.7637 26.4145 10.236 26.0891 9.91058C25.7678 9.58927 25.2493 9.5852 24.923 9.89838L10.8323 23.9891C10.8282 23.9932 10.8241 23.9973 10.8199 24.0013Z",
    fill: "#FF3A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleMissedVoiceCall);
export default __webpack_public_path__ + "static/media/people-missed-voice-call.1bd7a08e6ff29d99b1b3ddbd40627f84.svg";
export { ForwardRef as ReactComponent };